<template>
    <div>
        <headComponents></headComponents>
        <router-view></router-view>
        <bottomComVue></bottomComVue>
    </div>
</template>

<script>
import bottomComVue from '@/components/bottomCom.vue';
import headComponents from '@/components/head.vue';
export default {
    name: 'App',
    components: {
        headComponents,
        bottomComVue
    }
}
</script>

<style></style>
